import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex align-center mb-12 pb-6 gap-12 border-b border-b-gray-200 w-full" }
const _hoisted_2 = ["onClick"]

import { ref } from "vue";

// Array of button names

export default /*#__PURE__*/_defineComponent({
  __name: 'InternalViewNav',
  setup(__props) {

const buttons = ['Create', 'Add', 'Edit', 'Track', 'Push'];

// Track which button is active
const activeButton = ref(2);

// Function to set active button
const setActiveButton = (index: number) => {
  activeButton.value = index;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(buttons, (button, index) => {
      return _createElementVNode("button", {
        key: index,
        class: _normalizeClass(["px-4 py-2 rounded-lg transition-colors duration-300", {
                'bg-blue-600 text-white': activeButton.value === index,
                'bg-transparent text-gray-700 hover:bg-gray-100': activeButton.value !== index
            }]),
        onClick: ($event: any) => (setActiveButton(index))
      }, _toDisplayString(button), 11, _hoisted_2)
    }), 64))
  ]))
}
}

})